import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const DepositReportPagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange
}) => {
  const { t, i18n } = useTranslation();

  if (totalPages <= 1) return null;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  return (
    <div className="flex items-center justify-between mt-6">
      <div className="text-sm text-slate-600">
        {t('showing')} {startIndex + 1} {t('to')} {endIndex} {t('of')} {totalItems} {t('items')}
      </div>

      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`flex items-center gap-1 px-3 py-2 text-sm border rounded-lg transition-colors duration-200 ${currentPage === 1
              ? 'border-slate-200 text-slate-400 cursor-not-allowed'
              : 'border-slate-300 text-slate-600 hover:bg-slate-50'
            }`}
        >
          {i18n.language === 'ar' ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
          <span>{t('previous')}</span>
        </button>

        <div className="flex items-center gap-1">
          {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
            let pageNum;
            if (totalPages <= 5) {
              pageNum = i + 1;
            } else if (currentPage <= 3) {
              pageNum = i + 1;
            } else if (currentPage >= totalPages - 2) {
              pageNum = totalPages - 4 + i;
            } else {
              pageNum = currentPage - 2 + i;
            }

            return (
              <button
                key={pageNum}
                onClick={() => onPageChange(pageNum)}
                className={`px-3 py-2 text-sm border rounded-lg transition-colors duration-200 ${currentPage === pageNum
                    ? 'bg-blue-50 border-blue-300 text-blue-700'
                    : 'border-slate-300 text-slate-600 hover:bg-slate-50'
                  }`}
              >
                {pageNum}
              </button>
            );
          })}
        </div>

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`flex items-center gap-1 px-3 py-2 text-sm border rounded-lg transition-colors duration-200 ${currentPage === totalPages
              ? 'border-slate-200 text-slate-400 cursor-not-allowed'
              : 'border-slate-300 text-slate-600 hover:bg-slate-50'
            }`}
        >
          <span>{t('next')}</span>
          {i18n.language === 'ar' ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
        </button>
      </div>
    </div>
  );
};

export default DepositReportPagination;